import { capitalFirstLetter } from "./capitalFirstLetter";

export const getFormattedCountryName = (
	country: string,
	checkCountry: string,
	replacedName: string
): string => {
	const lower = country.toLowerCase();
	if (lower === checkCountry.toLowerCase()) return replacedName;

	const parts = country.split("-");
	const mainPart = parts[1] ? parts[1].trim() : parts[0].trim();
	return capitalFirstLetter(mainPart);
};
